import { sendAction } from '../core/action.js';
import { playSound } from '../core/play.js';

function playDropdownSound() {
    return playSound({
        soundsetName: 'dropmenu_button',
        action: 'click',
    });
}
function playOpenDialogSound() {
    return playSound({
        soundsetName: 'default_window',
        action: 'open',
    });
}
function playCloseDialogSound() {
    return playSound({
        soundsetName: 'default_window',
        action: 'close',
    });
}
function playInputSound() {
    return playSound({
        soundsetName: 'default_textinput',
        action: 'change',
    });
}
function playCheckboxSound() {
    return playSound({
        soundsetName: 'default_checkbox',
        action: 'click',
    });
}
function playButtonSound() {
    return playSound({
        soundsetName: 'default_button',
        action: 'press',
    });
}
function playProgressBarSectionOpenSound() {
    return playSound({
        soundsetName: 'default_progress_bar',
        action: 'press',
    });
}
function playBoosterWindowOpen() {
    return playSound({
        soundsetName: 'default_window_buster',
        action: 'open',
    });
}
function playBoosterBuyRegular() {
    return playSound({
        soundsetName: 'default_booster',
        action: 'buy',
    });
}
function playBoosterPressRegular() {
    return playSound({
        soundsetName: 'default_booster',
        action: 'press',
    });
}
function playBoosterBuyPremium() {
    return playSound({
        soundsetName: 'default_prem_booster',
        action: 'buy',
    });
}
function playBoosterPressPremium() {
    return playSound({
        soundsetName: 'default_prem_booster',
        action: 'press',
    });
}
function playShipBuildAnimationStart() {
    return playSound({
        soundsetName: 'default_build_ship',
        action: 'start',
    });
}
function playShipBuildAnimationEnd() {
    return playSound({
        soundsetName: 'default_build_ship',
        action: 'end',
    });
}
function playBoosterBuildAnimationStart() {
    return playSound({
        soundsetName: 'default_build_building',
        action: 'start',
    });
}
function playBoosterBuildAnimationEnd() {
    return playSound({
        soundsetName: 'default_build_building',
        action: 'end',
    });
}
function playShipYardOver() {
    return playSound({
        soundsetName: 'default_shipyard_over',
        action: 'over',
    });
}
function playShipYardSoftOver() {
    return playSound({
        soundsetName: 'default_shipyard_over',
        action: 'soft_over',
    });
}
function playBuyoutOver() {
    return playSound({
        soundsetName: 'default_ship_buyout',
        action: 'over',
    });
}
function playBuyoutOut() {
    return playSound({
        soundsetName: 'default_ship_buyout',
        action: 'out',
    });
}
function shipyardSoundOn() {
    return playSound({
        soundsetName: 'default_shipyard_sound',
        action: 'on',
    });
}
function shipyardSoundOff() {
    return playSound({
        soundsetName: 'default_shipyard_sound',
        action: 'off',
    });
}
function changeShipyardStage() {
    return playSound({
        soundsetName: 'default_shipyard_stage',
        action: 'change',
    });
}
function playCrewRandomVOSample(crewId) {
    return sendAction({
        actionId: 'playCrewRandomVOSample',
        crewId,
    });
}
function playButtonClickSound() {
    return playSound({
        soundsetName: 'button_secondary',
        action: 'click',
    });
}
function playButtonDialogClickSound() {
    return playSound({
        soundsetName: 'button_default',
        action: 'click',
    });
}
function playButtonWalletClickSound() {
    return playSound({
        soundsetName: 'button_credits',
        action: 'click',
    });
}
function playButtonGoldClickSound() {
    return playSound({
        soundsetName: 'button_gold',
        action: 'click',
    });
}
function playCheckboxClickSound() {
    return playSound({
        soundsetName: 'check_box',
        action: 'click',
    });
}
function playDropdownClickSound() {
    return playSound({
        soundsetName: 'dropdown',
        action: 'click',
    });
}
function playTabClickSound() {
    return playSound({
        soundsetName: 'button_tab',
        action: 'click',
    });
}
function playPaperCardClickSound() {
    return playSound({
        soundsetName: 'button_card',
        action: 'click',
    });
}
function playPopupOpenSound() {
    return playSound({
        soundsetName: 'default_screen',
        action: 'change',
    });
}
function playCardOverSound() {
    return playSound({
        soundsetName: 'button_flat',
        action: 'over',
    });
}
function playCardClickSound() {
    return playSound({
        soundsetName: 'button_flat',
        action: 'click',
    });
}
function playExchangeSound() {
    return playSound({
        soundsetName: 'default_exchange',
        action: 'exchange',
    });
}
function playSoldSound() {
    return playSound({
        soundsetName: 'default_messages',
        action: 'sold',
    });
}
var sound = {
    playDropdownSound,
    playOpenDialogSound,
    playCloseDialogSound,
    playInputSound,
    playCheckboxSound,
    playButtonSound,
    playProgressBarSectionOpenSound,
    playBoosterWindowOpen,
    playBoosterBuyRegular,
    playBoosterBuyPremium,
    playShipBuildAnimationStart,
    playShipBuildAnimationEnd,
    playBoosterBuildAnimationStart,
    playBoosterBuildAnimationEnd,
    playBoosterPressRegular,
    playBoosterPressPremium,
    playShipYardOver,
    playShipYardSoftOver,
    playBuyoutOver,
    playBuyoutOut,
    shipyardSoundOn,
    shipyardSoundOff,
    changeShipyardStage,
    playCrewRandomVOSample,
    playButtonClickSound,
    playButtonDialogClickSound,
    playButtonWalletClickSound,
    playButtonGoldClickSound,
    playCheckboxClickSound,
    playDropdownClickSound,
    playTabClickSound,
    playPaperCardClickSound,
    playPopupOpenSound,
    playCardOverSound,
    playCardClickSound,
    playExchangeSound,
    playSoldSound
};

export { changeShipyardStage, sound as default, playBoosterBuildAnimationEnd, playBoosterBuildAnimationStart, playBoosterBuyPremium, playBoosterBuyRegular, playBoosterPressPremium, playBoosterPressRegular, playBoosterWindowOpen, playButtonClickSound, playButtonDialogClickSound, playButtonGoldClickSound, playButtonSound, playButtonWalletClickSound, playBuyoutOut, playBuyoutOver, playCardClickSound, playCardOverSound, playCheckboxClickSound, playCheckboxSound, playCloseDialogSound, playCrewRandomVOSample, playDropdownClickSound, playDropdownSound, playExchangeSound, playInputSound, playOpenDialogSound, playPaperCardClickSound, playPopupOpenSound, playProgressBarSectionOpenSound, playShipBuildAnimationEnd, playShipBuildAnimationStart, playShipYardOver, playShipYardSoftOver, playSoldSound, playTabClickSound, shipyardSoundOff, shipyardSoundOn };
//# sourceMappingURL=index.js.map
